import NewMessageImage from './NewMessageImage';

export default NewMessageImage;



// WEBPACK FOOTER //
// ./app/javascript/common/components/NewMessageImage/index.js